export default __webpack_public_path__ + "static/media/filter_alt.7f0ba4bb.svg";